import { Outlet, Link, useLocation } from 'react-router-dom';
import { Shield } from 'lucide-react';

export const AppShell = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-bg text-text">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-bg/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center text-sm font-semibold tracking-wide text-white">
            <img
              src="https://i.ibb.co.com/tTY8V8dR/Renggani-Gallery-modern-logo-202606271426-removebg-preview.png"
              alt="Renggani Gallery"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <nav className="flex items-center gap-2">
            <Link
              to="/"
              className={`rounded-full px-4 py-2 text-sm ${location.pathname === '/' ? 'bg-white text-black' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}
            >
              Feed
            </Link>
            <Link
              to="/admin"
              className={`rounded-full px-4 py-2 text-sm ${location.pathname === '/admin' ? 'bg-white text-black' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}
            >
              <span className="inline-flex items-center gap-2"><Shield size={14} /> Admin</span>
            </Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
};